/** Server-render budget for live data: past this the page renders without it and the client fetches it. */
export const RENDER_BUDGET_MS = 2500;

/** Resolves to the value, or `null` if it rejects or takes longer than `timeoutMs`. */
export async function withinRenderBudget<T>(
  promise: Promise<T>,
  timeoutMs = RENDER_BUDGET_MS,
): Promise<T | null> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<null>((resolve) => {
        timer = setTimeout(() => resolve(null), timeoutMs);
      }),
    ]);
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
